{
  "projectedIncome": "Projected Income",
  "totalProjectedIncome": "Total Projected Income",
  "monthlyAverageIncome": "Average Monthly Income",
  "noData": "There is no projected income available"
}
